import { MediaFileType } from './constants';

export function getMediaFileType(url, fileName, mimeType) {
  // If explicitly a mimeType, check that first
  if (mimeType) {
    if (mimeType.startsWith('image/')) return MediaFileType.IMAGE;
    if (mimeType.startsWith('video/')) return MediaFileType.VIDEO;
    if (mimeType.startsWith('audio/')) return MediaFileType.AUDIO;
    if (mimeType === 'application/pdf') return MediaFileType.PDF;
    if (
      mimeType ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      mimeType === 'application/msword'
    ) {
      return MediaFileType.DOCX;
    }
    if (
      mimeType ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      mimeType === 'application/vnd.ms-excel'
    ) {
      return MediaFileType.EXCEL;
    }
    if (mimeType === 'text/csv') return MediaFileType.CSV;
    if (mimeType.startsWith('text/')) return MediaFileType.TEXT;
  }

  // Fallback to file extension
  const fileStr = (fileName || url || '').toLowerCase();

  if (/\.(jpe?g|png|gif|webp|svg)$/i.test(fileStr)) return MediaFileType.IMAGE;
  if (/\.(mp4|webm|mov|ogg)$/i.test(fileStr)) return MediaFileType.VIDEO;
  if (/\.(mp3|wav|ogg|opus|m4a)$/i.test(fileStr)) return MediaFileType.AUDIO;
  if (/\.pdf(\?.*)?$/i.test(fileStr)) return MediaFileType.PDF;
  if (/\.(docx?)(\?.*)?$/i.test(fileStr)) return MediaFileType.DOCX;
  if (/\.(xlsx?)(\?.*)?$/i.test(fileStr)) return MediaFileType.EXCEL;
  if (/\.csv(\?.*)?$/i.test(fileStr)) return MediaFileType.CSV;
  if (/\.(txt|json|md)(\?.*)?$/i.test(fileStr)) return MediaFileType.TEXT;

  return MediaFileType.UNSUPPORTED;
}

export function formatFileSize(bytes) {
  if (!bytes || isNaN(bytes)) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} kB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function downloadMedia(url, fileName) {
  const link = document.createElement('a');
  link.href = url;
  if (fileName) {
    link.download = fileName;
  }
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
